import { render, staticRenderFns } from "./ViewRTReport.vue?vue&type=template&id=88697680"
import script from "./ViewRTReport.vue?vue&type=script&lang=js"
export * from "./ViewRTReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports